import React, { type FunctionComponent, useState, Fragment } from 'react'
import styled from '@emotion/styled'
import { fontWeight, colors, fontSize } from '@retailer-platform/shared-components'
import SelectPartnerWarehouse from 'legacy/components/SelectPartnerWarehouse/SelectPartnerWarehouse'
import { useOnEnterHandler } from 'legacy/common/utils/keyboard/keyboard.utils'
import { usePartnerId } from 'utils/routing/params.hooks'
import { NavIconWrapper } from 'gin-and-tonic/containers/nav/components/NavIconWrapper'
import { useWarehouseContext } from 'utils/contexts/warehouse/WarehouseContext.hooks'

const Container = styled.div({
  height: 42,
  color: colors.GRAYSCALE.X0,
  fontSize: fontSize.X15,
  fontWeight: fontWeight.SEMIBOLD,
  boxSizing: 'border-box',
  width: 256,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
})

const StyledLogoImage = styled.img({
  width: 26,
  height: 26,
  background: 'white',
  borderRadius: '50%',
})

export const NavSelect: FunctionComponent = () => {
  const [modalOpen, setModal] = useState(false)
  const openModal = () => setModal(true)
  const closeModal = () => setModal(false)
  const partnerId = usePartnerId()
  const onEnterHandler = useOnEnterHandler(openModal)
  const warehouseContext = useWarehouseContext()

  const modalContent = (
    <SelectPartnerWarehouse
      initialPartnerId={Number(partnerId)}
      handleClose={closeModal}
      beforeRedirect={closeModal}
    />
  )

  return (
    <Fragment>
      <Container role="button" onClick={openModal} onKeyPress={onEnterHandler} tabIndex={0}>
        {warehouseContext.warehouse && (
          <Fragment>
            <NavIconWrapper>
              <StyledLogoImage src={warehouseContext.warehouse.logo.url} alt="logo" />
            </NavIconWrapper>
            {warehouseContext.warehouse.name}
          </Fragment>
        )}
      </Container>
      {modalOpen && modalContent}
    </Fragment>
  )
}
